'use strict';

var MarketProductGroupGridFilterFactory = function MarketProductGroupGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketProductGroupGridFilter() {
    DemandFilter.call(this, 'market-product-group', 'market-product-group-analysis');
    this.registerFilters(injectedFilters);
  }
  MarketProductGroupGridFilter.constructor = MarketProductGroupGridFilter;
  MarketProductGroupGridFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketProductGroupGridFilter;
};
MarketProductGroupGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupGridFilterFactory;